"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
// Recommended (default) MerkleTree options.
// - leaves are sorted by default to facilitate onchain verification of multiproofs.
exports.defaultOptions = {
    sortLeaves: true,
};
//# sourceMappingURL=options.js.map